<template>
  <section
    class="
      fixed
      z-50
      w-screen
      h-screen
      inset-0
      p-23
      roboto
      overflow-auto
      bg-skin-primary
    "
  >
    <div class="flex items-center text-skin-primary mb-xxl cursor-pointer" @click="closemodal">
      <ChevronLeft />
      <p class="font-medium text-xm">Regresar</p>
    </div>

    <p class="text-big text-skin-description mb-33 font-bold">Categorias</p>
    <ul class="mb-xxl px-23">
      <li
        class="
          text-skin-description
          flex
          items-center
          h-17
          w-full
          justify-between
          mb-8
          cursor-pointer
        "
        v-for="(curso, index) in GET_CATEGORIES"
        :key="index"
        @click="getCategory(curso.id, curso.name)"
      >
        <p class="text-big">{{ curso.name }}</p>
        <ChevronRight :stroke="'#EA560E'" :width="4" :height="5" />
      </li>
    </ul>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import ChevronLeft from "./icons/ChevronLeft.vue";
import ChevronRight from "./icons/ChevronRight.vue";
export default {
  components: {
    ChevronLeft,
    ChevronRight,
  },
  data() {
    return {
      cursos: ["Cursos nuevos", "Mejor valorados", "Favoritos", "Gratuitos"],
      categories: [
        "Marketing Médico",
        "Odontología",
        "Laboratorio",
        "Diabetes",
        "Telemedicina",
        "Peso saludable",
        "Gerencia de salud",
      ],
    };
  },
  computed: {
    ...mapGetters(["menuopen"]),
    ...mapGetters("categories", ["GET_CATEGORIES"]),
  },
  methods: {
    closemodal() {
      this.$store.commit("menuopen", false);
    },

    getCategory(id, name) {
      if (this.$router.name != "v2-categories") {
        this.$router.push({ name: "v2-categories", query:{q:''} });
      }
      this.$store.commit("menuopen", false);
      localStorage.setItem("cat", id);
      this.$store.commit("set_current", name);
      this.$store.dispatch("categoryCourses/get_categoryCourses", {
        categoryId: id,
        perPage: 1,
        currentPage: 1,
      });
    },
  },
  mounted() {
    this.$store.dispatch("categories/get_categories");
  },
};
</script>
